// import { useMutation } from "@tanstack/react-query";
import { useCliente } from "../../actions/clientes";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import style from "../../styles/form.module.css";
// import { GrabarCliente } from "../../actions/clientes";
// import { GrabarCli, BuscarCli } from "../../actions/clientes";

function ABMClientes() {
   // const token = localStorage.getItem("token");
   // const url = process.env.REACT_APP_URL_DIR + "cliente";
   // const [mailError, setMailError] = useState("");
   // const [documentoError, setDocumento] = useState("");
   const { SaveCliente } = useCliente();
   // var urlCli = url;
   // var metodo = "POST";
   // const urlProd = process.env.REACT_APP_URL_DIR + "estadosproducto";
   const estados = Estado();
   // const queryClient = useQueryClient();

   const location = useLocation();
   const { state } = location;
   const navigate = useNavigate();

   // const [cliente_id, setCliente_Id] = useState({ id: state ? state.id : 0 });

   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      nombre: state ? state.nombre : "",
      documento: state ? state.documento : "",
      email: state ? state.email : 0,
      telefono: state ? state.telefono : 0,
      fecha_nacimiento: state ? state.fecha_nacimiento : "",
      cod_status: state ? state.cod_status : "1",
   });

   var btnGrabar = true;

   function handleChange(e) {
      e.preventDefault();
      const { name, value } = e.target;
      
      // Validate documento: if it only contains numbers, it must be an integer (no decimals)
      if (name === "documento" && value !== "") {
         // Reject if it looks like a decimal number (digits with dot, no letters)
         if (/^\d*\.\d*$/.test(value)) {
            return;
         }
      }
      
      setInput({
         ...input,
         [name]: value,
      });
   }

   const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("handleSubmit : ", input);
      await SaveCliente.mutateAsync(input);
      navigate("/clientes");
   };

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Datos del Cliente</h1>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Cliente id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Nombre: </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Ingrese nombre del Cliente"
                        name="nombre"
                        value={input.nombre}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div style={{ display: "block" }}>
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>
                           Documento:{" "}
                        </span>
                        <input
                           className={style.input_field}
                           type="text"
                           placeholder="Ingrese el numero de documento"
                           name="documento"
                           value={input.documento}
                           onChange={handleChange}
                           required
                        />
                     </div>
                     {/* <div className={style.showerror}>
                        <p className={style.errormsg}>{documentoError}</p>
                     </div> */}
                  </div>
                  <div style={{ display: "block" }}>
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>E-Mail: </span>
                        <input
                           className={style.input_field}
                           type="text"
                           placeholder="Email del Cliente"
                           name="email"
                           value={input.email}
                           onChange={handleChange}
                           required
                        />
                     </div>
                     {/* <div className={style.showerror}>
                        <p className={style.errormsg}>{mailError}</p>
                     </div> */}
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Telefono:</span>
                     <label htmlFor="email"></label>
                     <input
                        className={style.input_field}
                        type="text"
                        id="telefono"
                        name="telefono"
                        value={input.telefono}
                        onChange={handleChange}
                     />
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Fecha de Nacimiento:</span>
                     <input
                        className={style.input_field}
                        type="date"
                        id="fecha_nacimiento"
                        name="fecha_nacimiento"
                        value={input.fecha_nacimiento}
                        onChange={handleChange}
                     />
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/clientes");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMClientes;
